// Canonical state machines for Atlas entities.
// Mirrors mcp-servers/atlas-domain/src/state-machines.ts and specs/domain/state-machines.md.
const PROPOSTA = [
    { event: "simular", from: "_start", to: "simulada" },
    { event: "aceitar_simulacao", from: "simulada", to: "criada" },
    { event: "enviar_banco", from: "criada", to: "em_analise" },
    { event: "banco_aprova", from: "em_analise", to: "aprovada" },
    { event: "banco_rejeita", from: "em_analise", to: "rejeitada" },
    { event: "confirmar", from: "aprovada", to: "contratada" },
    { event: "cancelar", from: "aprovada", to: "cancelada" },
    { event: "cancelar", from: "contratada", to: "cancelada" },
    { event: "prefeitura_averba", from: "contratada", to: "averbada" },
    { event: "primeira_parcela", from: "averbada", to: "ativa" },
    { event: "quitar", from: "ativa", to: "quitada" },
];
const CONTRATO = [
    { event: "criar", from: "_start", to: "pendente" },
    { event: "averbar", from: "pendente", to: "averbado" },
    { event: "primeira_parcela_paga", from: "averbado", to: "em_dia" },
    { event: "parcela_atrasada", from: "em_dia", to: "inadimplente" },
    { event: "regularizar", from: "inadimplente", to: "em_dia" },
    { event: "quitar", from: "em_dia", to: "quitado" },
    { event: "quitar", from: "inadimplente", to: "quitado" },
    { event: "cancelar", from: "em_dia", to: "cancelado" },
    { event: "cancelar", from: "inadimplente", to: "cancelado" },
];
// Fonte de verdade do rito: portabilidade.ts. Esta lista e' o espelho para
// quem consulta por `nextState`/`allowedEvents`.
const PORTABILIDADE = [
    { event: "proponente_inicia", from: "_start", to: "aguardando_servidor" },
    { event: "servidor_inicia", from: "_start", to: "aguardando_proposta" },
    ...[
        ["aguardando_proposta", "informar_condicoes", "aguardando_servidor"],
        ["aguardando_servidor", "informar_condicoes", "aguardando_servidor"],
        ["solicitada", "informar_condicoes", "aguardando_servidor"],
        ["aguardando_pagamento", "informar_condicoes", "aguardando_servidor"],
        ["aguardando_liquidacao", "informar_condicoes", "aguardando_servidor"],
        ["aguardando_servidor", "servidor_confirma", "solicitada"],
        ["solicitada", "informar_saldo", "aguardando_pagamento"],
        ["aguardando_pagamento", "informar_pagamento", "aguardando_liquidacao"],
        ["aguardando_liquidacao", "liquidar", "concluida"],
    ].map(([from, event, to]) => ({ event, from, to })),
    ...["aguardando_proposta", "aguardando_servidor", "solicitada", "aguardando_pagamento", "aguardando_liquidacao"].flatMap((from) => [
        { event: "cancelar", from, to: "cancelada" },
        { event: "expirar", from, to: "expirada" },
    ]),
];
const RESERVA = [
    { event: "reservar", from: "_start", to: "ativa" },
    { event: "confirmar", from: "ativa", to: "confirmada" },
    { event: "expirar", from: "ativa", to: "expirada" },
];
const MAP = {
    proposta: PROPOSTA,
    contrato: CONTRATO,
    portabilidade: PORTABILIDADE,
    reserva: RESERVA,
};
export function nextState(entity, current, event) {
    const t = MAP[entity].find((x) => x.from === current && x.event === event);
    return t ? t.to : null;
}
export function allowedEvents(entity, current) {
    return MAP[entity].filter((t) => t.from === current).map((t) => t.event);
}
//# sourceMappingURL=state-machine.js.map